import { useState, useEffect } from 'react';
import { LanguageProvider, useLang } from '../../context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import TrustBrands from './components/TrustBrands';
import HowItWorks from './components/HowItWorks';
import WhyChooseUs from './components/WhyChooseUs';
import Footer from './components/Footer';

function FloatingWhatsApp() {
  const [show, setShow] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href="https://wa.me/37360123456?text=Buna%20ziua!%20Doresc%20un%20deviz%20gratuit."
      target="_blank"
      rel="nofollow noreferrer"
      className={`fixed bottom-6 right-4 md:bottom-8 md:right-8 z-50 flex items-center gap-2.5 pl-4 pr-4 py-3 md:pl-5 md:pr-5 md:py-3.5 rounded-full bg-neon text-charcoal font-rajdhani font-bold text-sm shadow-[0_0_24px_rgba(0,255,136,0.6)] hover:shadow-[0_0_40px_rgba(0,255,136,0.9)] transition-all duration-500 hover:scale-105 cursor-pointer whitespace-nowrap ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionProperty: 'opacity, transform, box-shadow' }}
    >
      <i className="ri-whatsapp-line text-xl"></i>
      <span className="hidden sm:inline">{t('Cere Deviz Gratuit', 'Запросить смету')}</span>
    </a>
  );
}

function HomeContent() {
  return (
    <div className="bg-charcoal font-inter w-full overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <TrustBrands />
        <HowItWorks />
        <WhyChooseUs />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default function HomePage() {
  return (
    <LanguageProvider>
      <HomeContent />
    </LanguageProvider>
  );
}
